import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";

const TmbMsiPdl = React.lazy(() => import("."));

function TmbMsiPdlLazyLoadWrapper(props) {
  const {tmbTotal, Fullscreen,tmbData,Highcharts,tmboptions,msiData,msiTotal,msioptions,pdloptions,pdlTotal,pdlData,TmbMsiPdlLoader} = props;

  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // TmbMsiPdlAPICall()
          observer.disconnect(); 
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return (
    <Fragment>
      <div ref={containerRef} 
      // style={{ minHeight: "500px" }}
      >
        {isVisible && (
         <Suspense fallback={<ShimmerLoader />}>
            {TmbMsiPdlLoader === true && <ShimmerLoader />}
            {TmbMsiPdlLoader === false && tmbData != null && msiData != null && msiTotal != null && <TmbMsiPdl
              tmbTotal={tmbTotal}
              Fullscreen={Fullscreen}
              tmbData={tmbData}
              Highcharts={Highcharts}
              tmboptions={tmboptions}
              msiData={msiData}
              msiTotal={msiTotal}
              msioptions={msioptions}
              pdloptions={pdloptions}
              pdlTotal={pdlTotal}
              pdlData={pdlData}
            />}
          </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default TmbMsiPdlLazyLoadWrapper;
